import CampaignsView from '@/views/app/campaigns/campaigns-view'
import CampaignsList from '@/modules/campaigns/_shared/campaigns-list'
import CampaignsListRecent from '@/modules/campaigns/_shared/campaigns-list-recent'
import CampaignApproved from '@/modules/campaigns/_shared/campaign-approve'
import CampaignsPreApproved from '@/modules/campaigns/_shared/campaign-pre-approved'
import CampaignsGuards from '@/guards/campaigns.guards'
export default [
  {
    path: 'campaigns',
    name: 'campaigns',
    component: CampaignsView,
    children: [
      {
        path: 'all',
        name: 'campaigns-list',
        component: CampaignsList,
        beforeEnter: CampaignsGuards.allCampaigns
      },
      {
        path: 'recent',
        name: 'campaigns-list-recent',
        component: CampaignsListRecent,
        beforeEnter: CampaignsGuards.recentCampaigns
      },
      {
        path: 'publish',
        name: 'campaigns-list-approve',
        component: CampaignApproved,
        beforeEnter: CampaignsGuards.allCampaigns
      },
      {
        path: 'pre-approved',
        name: 'campaigns-pre-approve',
        component: CampaignsPreApproved,
        beforeEnter: CampaignsGuards.allCampaigns
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/app/campaigns/index.js